let order_Menu = require("../../templates/order/Menu.handlebars");
let Backbone = require("backbone");
import POS from "../../POS.js";
let _ = require("underscore");
let MenuCategoryListView = require("./MenuCategoryListView.js");
import MenuItemListView from "./MenuItemListView.js";
let BasePagingModel = require("../../model/BasePagingModel.js");
let MenuCategoryCollection = require("../../collection/MenuCategoryCollection.js");

let main = function () {
    return Backbone.View.extend({

        menuCategoryListView: null,
        menuItemListView: null,
        events: {},

        initialize: function () {

            this.menuCategoryListView = new MenuCategoryListView({
                model: new BasePagingModel({
                    collection: this.collection
                })
            });

            this.menuItemListView = new MenuItemListView({
                model: new BasePagingModel()
            });
            this.listenTo(this.menuItemListView, "selectMenuItem", function (params) {
                console.log("menu view, menu item selected", params);

                if (params.packageItems) {
                    const items = this.getAllItems();
                    const packageItemsWithTags = _.mapObject(params.packageItems, function (selectedItems, name) {
                        return selectedItems.map(function (item) {
                            const menuItem = items.get(item.id);
                            const tags = menuItem.get("tags");
                            if (tags && tags.length > 0) {
                                const newItem = _.clone(item);
                                newItem.tags = tags.toJSON();
                                return newItem;
                            } else {
                                return item
                            }
                        });
                    });
                    params.packageItems = packageItemsWithTags;
                }
                this.trigger("selectMenuItem", params);
            });
            this.listenTo(this.menuCategoryListView, "selectCategory", this.onSelectCategory);
            this.listenTo(this.menuCategoryListView, "showAllCategory", this.showAllCategory);
            this.listenTo(this.menuItemListView, "selectMenuCategory", this.selectMenuCategory);
        },

        _prev: function () {
            this.menuItemListView.onPrev();
        },
        _next: function () {
            this.menuItemListView.onNext();
        },
        render: function () {
            this.$el.html(order_Menu());
            this.menuCategoryListView.setElement(this.$(".catView"));
            this.menuItemListView.setElement(this.$(".itemView"));

            this.menuCategoryListView.render();
            this.menuItemListView.render();
            return this;
        },

        query: function (code) {
            var collection = new Backbone.Collection(), shortCode;
            code = code.toLowerCase();

            const start = new Date().getTime();

            if (!this.availableItems) {
                console.log('creating items!!');
                this.availableItems = [];
                var self = this;
                POS.getMenu().getCategories().getAvailableCategories().forEach(function (category) {
                    category.getMenuItems().getAvailableItemCollection().forEach(function (item) {
                        self.availableItems.push(item);
                    });
                });
            }

            console.log('filter items!!');
            this.availableItems.forEach(function (item) {
                shortCode = item.get("shortCode");
                if (shortCode) {
                    shortCode = shortCode.toLowerCase();

                    if (shortCode.contains(code)) {
                        collection.push(item);
                    }

                } else if (item.get("pinyin").contains(code)) {
                    collection.push(item);
                } else if (item.get("shortPinyin").contains(code)) {
                    collection.push(item);
                } else if (item.get("name").toLowerCase().indexOf(code.toLowerCase()) >= 0) {
                    collection.push(item);
                }
            });

            console.log('menu filter takes ', new Date().getTime() - start);
            this.menuItemListView.model.set({
                collection: collection
            });
            if (code.length === 0) {
                this.menuCategoryListView.$el.find('.cell-wrapper:first').click();
            }
            this.menuItemListView.render();
            return this;
        },
        confirmFirst: function () {
            this.menuItemListView.confirmFirst();
        },
        selectMenuCategory: function (params) {
            console.log(params);
            var self = this;
            var cat = self.menuCategoryListView.model.get("collection").findWhere({id: params.catid});
            var index = self.menuCategoryListView.model.get("collection").indexOf(cat);
            self.menuCategoryListView.model.toIndexPage(index);
            self.menuCategoryListView.render();
            self.menuCategoryListView.chooseCategory(cat);
        },
        onSelectCategory: function (category) {
            if (category) {
                if (category.id == 0) {
                    this.menuItemListView.model.set({
                        collection: this.getAllItems(),
                        catName: category.get('name'),
                        showCat: false,
                        allCollection:this.getAllItems(),
                    });
                } else {
                    var collection = new Backbone.Collection();
                    category.getMenuItems().getAvailableItemCollection("father").forEach(function (item) {
                        item.set({"showSoldOutStyle": false});
                        collection.push(item);
                    });
                    category.getMenuItems().getSoldOutItemCollection("father").forEach(function (item) {
                        item.set({"showSoldOutStyle": true});
                        collection.push(item);
                    });

                    this.menuItemListView.model.set({
                        allCollection:this.getAllItems(),
                        collection: collection,
                        catName: category.get('name'),
                        showCat: false
                    });
                }
            }
            this.menuItemListView.render();
        },

        showAllCategory: function () {
            var menu = POS.getMenu(),
                collection = new Backbone.Collection();
            collection = menu.getCategories().getAvailableCategories();
            this.menuItemListView.model.set({
                collection: collection,
                showCat: true
            });
            this.menuItemListView.render();
        },
        getAllItems: function () {
            var menu = POS.getMenu(),
                collection = new Backbone.Collection();
            menu.getCategories().getAvailableCategories().forEach(function (category) {
                category.getMenuItems().getAvailableItemCollection().forEach(function (item) {
                    item.set({"showSoldOutStyle": false});
                    collection.push(item);
                });
                category.getMenuItems().getSoldOutItemCollection().forEach(function (item) {
                    item.set({"showSoldOutStyle": true});
                    collection.push(item);
                });
            });
            return collection;
        }
    });

};

let exportedValue = main();

export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/order/MenuView.js